// extracted by mini-css-extract-plugin
export default {"loader_container":"loader_loader_container__ZOVVu","loader_title":"loader_loader_title__8KXtJ","spinner":"loader_spinner__MZ2v1"};